const GET_CATEGORIES = 'GET_CATEGORIES';
const GET_CATEGORIES_BY_STATUS = 'GET_CATEGORIES_BY_STATUS';
const SEARCH_TICKET_CATEGORIES_AND_TYPES = 'SEARCH_TICKET_CATEGORIES_AND_TYPES';
const EMPTY_SEARCH_RESULTS = 'EMPTY_SEARCH_RESULTS';
const GET_TICKET_CATERGORIES_AND_TYPES = 'GET_TICKET_CATERGORIES_AND_TYPES';
const RENAME_CATEGORY = 'RENAME_CATEGORY';
const GET_WORKFLOW_TYPES = 'GET_WORKFLOW_TYPES';
const GET_WORKGROUPS = 'GET_WORKGROUPS';
const GET_PERMISSIONS = 'GET_PERMISSIONS';
const GET_WORKFLOWS_BY_CATEGORY = 'GET_WORKFLOWS_BY_CATEGORY';
const EMPTY_TICKET_TYPE_SELECTION_RESULTS = 'EMPTY_TICKET_TYPE_SELECTION_RESULTS';
const SELECT_CATEGORY = 'SELECT_CATEGORY';
const OPEN_TICKET_TYPE_FORM = 'OPEN_TICKET_TYPE_FORM';
const OPEN_TICKET_DETAILS_DRAWER = 'OPEN_TICKET_DETAILS_DRAWER';
const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE';
const EDIT_TICKET_TYPE_RECORD = 'EDIT_TICKET_TYPE_RECORD';
const TICKET_TYPE_FORM_STATE = 'TICKET_TYPE_FORM_STATE';
const SHOW_CATEGORY_SUCCESS_MSG = 'SHOW_CATEGORY_SUCCESS_MSG';
const SHOW_TICKET_CATEGORY_NAVIGATION = 'SHOW_TICKET_CATEGORY_NAVIGATION';

export const TICKET_MGMT_TYPES = {
    GET_CATEGORIES,
    GET_CATEGORIES_BY_STATUS,
    GET_TICKET_CATERGORIES_AND_TYPES,
    SEARCH_TICKET_CATEGORIES_AND_TYPES,
    EMPTY_SEARCH_RESULTS,
    RENAME_CATEGORY,
    GET_WORKFLOW_TYPES,
    GET_WORKGROUPS,
    GET_PERMISSIONS,
    GET_WORKFLOWS_BY_CATEGORY,
    EMPTY_TICKET_TYPE_SELECTION_RESULTS,
    SELECT_CATEGORY,
    OPEN_TICKET_TYPE_FORM,
    OPEN_TICKET_DETAILS_DRAWER,
    SHOW_SUCCESS_MESSAGE,
    EDIT_TICKET_TYPE_RECORD,
    TICKET_TYPE_FORM_STATE,
    SHOW_CATEGORY_SUCCESS_MSG,
    SHOW_TICKET_CATEGORY_NAVIGATION
};
